angular.module('iqxCore')
  .controller('TimesheetsApproveCtrl', function ($scope, $http, $window, FormSvc, ApplicationSvc, sendMessageDialogSvc, $filter) {
    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/NetTimesheetsForApproval',
      dateFields: ['weekenddate'],
      numberFields: ['timesheettotal', 'timesheethours'],
      booleanFields: ['hasScannedImage'],
      multiRow: true,
      autoEdit: true,
    })

    $scope.searchTS = ""

    $scope.choices = [
      { desc: "Close", type: "primary", code: '' },
    ]

    if (!$scope.isSwitchedOn('POPUPDOCUPDISABLE')) {
      $scope.choices.push({ desc: "Message", type: "warning", code: 'M' })
    }
    $scope.showRates = $scope.userHasRight('TSSHOWRATES')

    $scope.fetchTimesheetShifts = function (ts) {
      return $scope.fetch({
        fetchAPI: 'callresult/nettimesheetshifts?pTempTimesheetID=' + ts.temptimesheetid,
        fetchTarget: 'timesheetShifts', multiRow: true, dateFields: ['shiftdate']
      })
        .then(function () {
          angular.forEach($scope.timesheetShifts, function (sh) { sh.hours = sh.shiftduration })
          ts.timesheetShifts = $scope.timesheetShifts
          delete $scope['timesheetShifts']
        })
    }

    $scope.fetchTimesheetTimes = function (ts) {
      return $scope.fetch({
        fetchAPI: 'callresult/nettimesheettimes?pTempTimesheetID=' + ts.temptimesheetid,
        fetchTarget: 'timesheetShifts', multiRow: true, dateFields: ['shiftdate']
      })
        .then(function () {
          ts.timesheetShifts = $scope.timesheetShifts
          delete $scope['timesheetShifts']
        })
    }

    $scope.sendMessage = function (ts) {
      return sendMessageDialogSvc.createMessageFromDialog($scope, 'TIMESHEET', 'Query Timesheet ' + ts.serialnumber, { ptimesheetid: ts.temptimesheetid })
    }

    $scope.expandTimesheetDialog = function (ts) {
      return FormSvc.modalInfo($scope, 'timesheetInfo', ts, 'md')
        .then(function (choice) {
          if (choice == 'M') {  // They clicked the 'Message' choice button
            return $scope.sendMessage(ts)
          }
        })
    }

    $scope.expandTimesheet = function (ts) {
      if (ts.timesheetRates) { return $scope.expandTimesheetDialog(ts) }  // Avoid re-fetching
      ts.choices = $scope.choices
      ts.showRates = $scope.showRates
      $scope.fetch({
        fetchAPI: 'callresult/nettimesheetrates?pTempTimesheetID=' + ts.temptimesheetid,
        fetchTarget: 'timesheetRates', booleanFields: ['IsExpenses'], multiRow: true
      })
        .then(function () {
          ts.timesheetRates = $scope.timesheetRates
          angular.forEach(ts.timesheetRates, function (rt) {
            if (rt.IsExpenses) { ts.rateExpenses = true }
          })
          if (ts.timesheettype == 'S') {
            ts.fetchTimesheetShifts = $scope.fetchTimesheetShifts
          } else if (ts.timesheettype == 'T') {
            ts.fetchTimesheetShifts = $scope.fetchTimesheetTimes
          } else {
            ts.fetchTimesheetShifts = angular.noop
          }
          return $scope.expandTimesheetDialog(ts)
        })
    }

    $scope.selectAll = function (bOn) {
      angular.forEach($filter('filter')($scope.theRecords, $scope.searchTS), function (ts) {
        ts.tick = bOn
      })
    }

    $scope.approveSelected = function () {
      $scope.formError = ''
      var ar = []
      angular.forEach($scope.theRecords, function (ts) {
        if (ts.tick) {
          ar.push(ts.temptimesheetid)
        }
      })
      if (ar.length == 0) { return ApplicationSvc.showMessage('Error', 'Nothing selected', true) }
      ApplicationSvc.queryMessage('Please Confirm', $scope.params.lang.pages.timesheets.appr.approve + ' ' + ar.length + ' timesheet(s)')
        .then(function () {
          return $scope.exec('call/NetTimesheetApprove', { pTempTimesheetList: ar.join() })
        })
        .then(function () {
          $scope.searchTS = ""
          return $scope.fetch()
        })
    }

    $scope.showImage = function ($event, ts) {
      $event.stopPropagation()  // Prevent row click drill down
      $scope.formError = ''
      $http.get('/api/document/doxi', { params: { Type: 'TIMESHEET', 'TimesheetID': ts.temptimesheetid } })
        .then(function (res) {
          $window.open('/api/document/download?doxi=' + res.data, '_blank')
        })
        .catch(function (err) {
          $scope.formError = ApiSvc.ExtractError(err)
        })
    }

    $scope.fetch()

  })
